import React, { useEffect } from 'react';

import { useNavigate } from 'react-router-dom';
import { Loader } from 'app/shared/loader/loader';
import axios from 'axios';
import Keycloak from 'keycloak-js';
import { AUTH_TOKEN_KEY, successLogin } from 'app/shared/reducers/authentication';
import { IUser, JWTUser } from 'app/shared/model/user.model';
import jwt from 'jwt-decode';
import { useAppDispatch } from 'app/config/store';

export const LogoutDeniedRedirect = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  useEffect(() => {
    axios
      .get('api/keycloak-properties')
      .then(response => {

        const keycloak = new Keycloak({
          url: response.data.keycloakUrl,
          realm: response.data.keycloakRealm,
          clientId: response.data.keycloakClientId,
        });

        keycloak
          .init({ onLoad: 'check-sso' })
          .then(auth => {
            if (auth) {
              axios
                .post('api/authenticate', {
                  keycloakToken: keycloak.token,
                  keycloakRefreshToken: keycloak.refreshToken,
                })
                .then(res => {
                  onSuccessAuthentication(res);
                })
                .catch(console.error);
            } else {
              navigate('/');
            }
          })

      })

  }, []);

  const onSuccessAuthentication = res  => {
    const bearerToken = res.headers.authorization;
    const token = bearerToken.slice(7, bearerToken.length);
    localStorage.setItem(AUTH_TOKEN_KEY, token);

    const user: JWTUser = jwt(token);
    const iuser: IUser = {
      id: user.idUser,
      firstName: user.firstName,
      lastName: user.lastName,
      authorities: user.authorities,
      userSelected: user.userSelected,
      szIsZastupanje: user.szIsZastupanje,
      szIpsRegistar: user.szIpsRegistar,
      szSubjectOfRepresentationSelected: user.szSubjectOfRepresentationSelected
    };
    dispatch(successLogin(iuser));

    const forPersonOib = sessionStorage.getItem('forPersonOib') || '';
    const forIps = sessionStorage.getItem('forIps') || '';
    const forIzvorReg = sessionStorage.getItem('forIzvorReg') || '';
    const toIps = sessionStorage.getItem('toIps') || '';
    const toIzvorReg = sessionStorage.getItem('toIzvorReg') || '';

    // ako je korisnik bio odabrao neki subjekt u nias popupu, ponoviti tu akciju
    if (forPersonOib || forIps) {
      const httpParams = {
        forPersonOib: forPersonOib,
        forIps: forIps,
        forIzvorReg: forIzvorReg,
        toIps: toIps,
        toIzvorReg: toIzvorReg,
      };

      axios.get('/api/change-subject', { params: httpParams })
        .then(response => {
          const newToken = response.data.id_token;
          localStorage.setItem(AUTH_TOKEN_KEY, newToken);
          const newUser: JWTUser = jwt(newToken);
          const newIuser: IUser = {
            id: newUser.idUser,
            firstName: newUser.firstName,
            lastName: newUser.lastName,
            authorities: newUser.authorities,
            userSelected: newUser.userSelected,
            szIsZastupanje: newUser.szIsZastupanje,
            szIpsRegistar: newUser.szIpsRegistar,
            szSubjectOfRepresentationSelected: newUser.szSubjectOfRepresentationSelected
          };
          dispatch(successLogin(newIuser));
          window.location.href = '/';
        })
        .catch(error => {
          console.error('Error fetching data:', error);
        });
    }
  }

  return <Loader />;
};

export default LogoutDeniedRedirect;
